import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { X } from "lucide-react";

// Record focus coming from the command palette: ?q=<ref|name>&tab=<tab>
export function useFocus(defaultTab) {
  const [sp, setSp] = useSearchParams();
  const q = (sp.get("q") || "").trim();
  const [tab, setTab] = useState(sp.get("tab") || defaultTab);
  useEffect(() => { if (sp.get("tab")) setTab(sp.get("tab")); }, [sp]);
  const hit = useMemo(() => { const n = q.toLowerCase(); return (row, fields) => !!n && fields.some((f) => String(row?.[f] || "").toLowerCase().includes(n)); }, [q]);
  const filter = (rows, fields) => (q ? (rows || []).filter((r) => hit(r, fields)) : rows || []);
  const clear = () => { const n = new URLSearchParams(sp); n.delete("q"); setSp(n, { replace: true }); };
  const rowCls = (row, fields) => (hit(row, fields) ? "ring-2 ring-inset ring-amber-400/70 bg-amber-400/5" : "");
  return { q, tab, setTab, hit, filter, clear, rowCls };
}

export function FocusChip({ q, clear, count }) {
  if (!q) return null;
  return <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-3 py-1 text-xs" data-testid="focus-chip">
    <span>Showing <b className="font-mono">{q}</b>{count != null && <span className="text-muted-foreground"> · {count} match{count === 1 ? "" : "es"}</span>}</span>
    <button type="button" onClick={clear} data-testid="focus-clear" className="rounded-full p-0.5 hover:bg-amber-400/20" aria-label="Clear filter"><X className="h-3 w-3" /></button>
  </div>;
}
